import { useQuery } from '@tanstack/react-query';
import { fetchEmployerDashboardSummary, type EmployerDashboardSummary } from '../api/employerDashboard';

export function useEmployerDashboardSummary() {
  return useQuery<EmployerDashboardSummary>({
    queryKey: ['employer-dashboard'],
    queryFn: fetchEmployerDashboardSummary,
    staleTime: 1000 * 60 * 2,
    retry: 2,
    retryDelay: (attempt) => Math.min(1000 * 2 ** attempt, 8000),
  });
}
